import { combineReducers } from 'redux'

import editor from './editor'
import templateFilters from './templateFilters'

export default combineReducers({
  editor,
  templateFilters,
})
